import React, { useEffect, useState } from 'react';
import NumberOfOffer from 'atomic/number-of-offer';
import Link from 'atomic/link';
import Badge from 'atomic/badge';
import Rating from 'atomic/rating';
import Price from 'atomic/price';
import classNames from 'classnames';
import { CarouselProps } from 'react-multi-carousel';
import WidgetPhotosGridTeaserProps from 'modules/shared/widgets/components/widget-photos-grid-teaser/widget-photos-grid-teaser.props';
import WidgetCarouselDesktopBasic
    from '../../../../widget-carousel/widget-carousel-deskktop/components/widget-carousel-desktop-basic/widget-carousel-desktop-basic';
import AlertDiscountPriceInfo from 'modules/shared/components/alert-discount-price-info';
import WidgetAttributesTable from 'modules/shared/widgets/shared/widget-attributes-table';

import './widget-photos-grid-teaser-desktop-slider.scss';

interface WidgetPhotosGridTeaserSliderProps extends WidgetPhotosGridTeaserProps {
    isSliderSmall: boolean;
}

const WidgetPhotosGridTeaserDesktopSlider: React.FC<WidgetPhotosGridTeaserSliderProps> = ({ config, data, isSliderSmall }) => {
    const [WidgetPhotosGridTeaserCarouselComponent, setWidgetCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetCarouselDesktopBasic);
    const numberOfItems = isSliderSmall ? 3 : 5;
    const { items } = data;

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: numberOfItems
        }
    };

    return (
        <div className={classNames({
            'widget-photo-grid-teaser-carousel': true,
            'widget-photo-grid-teaser-carousel__small': numberOfItems === 3
        })}
        >
            <WidgetPhotosGridTeaserCarouselComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                slidesToSlide={numberOfItems}
                renderButtonGroupOutside={true}
                arrows={true}
                autoPlay={config.autoPlay}
                className="w-carousel-d__list"
                itemClass={`w-carousel-d__list__item w-${numberOfItems}`}
            >
                {(items || []).map(item => (
                    <div key={item.id} className="slider__list__item-wrapper">
                        <div className="slider__list__item-wrapper__stars">
                            <Rating size="sm" opinions={item.opinions}/>
                        </div>
                        <Link
                            href={item.url}
                            title={item.name}
                            className="slider__list__item-content"
                        >
                            <div className={'slider__list__item-content__image'}>
                                <img
                                    src={item.photo}
                                    alt={item.name}
                                    title={item.name}
                                    loading={config.lazyLoad ? 'lazy' : 'eager'}
                                />
                                {item.discount > 0 && (
                                    <div className="slider__list__item-content__image__badges">
                                        <Badge color="red">
                                            <span>{item.discount}%</span>
                                        </Badge>
                                    </div>
                                )}
                            </div>
                            <div className="slider__list__item-content__title">
                                <h3>
                                    {item.name}
                                </h3>
                            </div>
                            <div className="slider__list__item-content__stars-placeholder"/>
                            <div className="slider__list__item-content__price">
                                <Price price={item.minPrice} weight={700}/>
                                {item.discount > 0 && (
                                    <Price
                                        className="discount"
                                        price={item.minPrice + (item.minPrice * (Math.abs(item.discount) / (100 - Math.abs(item.discount))))}
                                        crossed={true}
                                        color="red"
                                        weight={500}
                                    />
                                )}
                            </div>
                            {item.discount > 0 && (
                                <div className="slider__list__item-content__discount-info">
                                    <AlertDiscountPriceInfo paddingTop={0} paddingBottom={6}/>
                                </div>
                            )}
                            {item.discount === 0 && item.attributes && (
                                <div className="slider__list__item-content__attributes">
                                    <WidgetAttributesTable attributes={item.attributes} rowsNumber={3}/>
                                </div>
                            )}
                            <div className="slider__list__item-content__number-of-offer">
                                <NumberOfOffer offers={item.offers}/>
                            </div>
                        </Link>
                    </div>
                ))}
            </WidgetPhotosGridTeaserCarouselComponent>
        </div>
    );
};

export default WidgetPhotosGridTeaserDesktopSlider;
